<template>
  <div class="flashcard-body">
    <div
      v-if="showStem"
      class="flashcard-stem"
      v-html="questionHtml"
    >
    </div>

    <div v-if="hasCustomComponent">
      <component
        :is="flashcardType"
        :flashcard="flashcard"
        :flashcard-state="flashcardState"
        @answers-selected="answersSelected"
        @set-raw-answer-data="setRawAnswerData"
      ></component>
    </div>
    <div
      v-else
      class="not-supported"
    >
      <p>Flashcard type not supported - {{ flashcardType }}</p>
    </div>
  </div>
</template>

<script>
import Bowtie from './flashcard-types/BowTie.vue';
import ClozeDropdown from './flashcard-types/ClozeDropdown.vue';
import DragAndDrop from './flashcard-types/DragAndDrop.vue';
import Highlight from './flashcard-types/Highlight.vue';
import Hotspot from './flashcard-types/Hotspot.vue';
import MatrixGrid from './flashcard-types/MatrixGrid.vue';
import MultipleChoice from './flashcard-types/MultipleChoice.vue';
import NumericEntry from './flashcard-types/NumericEntry.vue';
import OrderedResponse from './flashcard-types/OrderedResponse.vue';
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import FlashcardViewMixin from '@/mixins/flashcardViews';
import Icon from '@components/singletons/icon';

export default {
  components: {
    Bowtie,
    ClozeDropdown,
    DragAndDrop,
    Highlight,
    Hotspot,
    MatrixGrid,
    MultipleChoice,
    NumericEntry,
    OrderedResponse,
    Icon,
  },
  mixins: [WuxSimulationsMixin, FlashcardViewMixin],
  props: {
    flashcard: {
      type: Object,
      required: true,
    },
    flashcardState: {
      type: Object,
      required: true,
    },
  },
  computed: {
    flashcardType() {
      const type = this.flashcard?.type?.toLowerCase().split(' ').join('-');
      if (type === 'sata') {
        return 'multiple-choice';
      } else if (type === 'cloze-/-dropdown') {
        return 'cloze-dropdown';
      }
      return type;
    },
    componentsAvailable() {
      return Object.keys(this.$options.components).map((cName) => this.pascalToKebabCase(cName));
    },
    hasCustomComponent() {
      return this.componentsAvailable.includes(this.flashcardType);
    },
    showStem() {
      if (this.flashcard.type === 'Highlight') return false;
      if (this.flashcard.type === 'Cloze / Dropdown') return false;
      return true;
    },
    questionHtml() {
      if (!this.flashcard.question?.startsWith('<p>')) {
        return `<p>${this.flashcard.question}</p>`;
      }
      return this.flashcard.question;
    },
  },
  methods: {
    answersSelected(answerIds) {
      this.$emit('answers-selected', answerIds);
    },
    setRawAnswerData(data) {
      this.$emit('set-raw-answer-data', data);
    },
    pascalToKebabCase(str) {
      return str
        .split(/(?=[A-Z])/)
        .map((word) => word.toLowerCase())
        .join('-');
    },
  },
};
</script>

<style lang="scss" scoped>

.flashcard-stem {
  font-size: 1rem;
}

.flashcard-stem > :first-child {
  margin-top: 0;
}

.not-supported {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
  padding: 1rem;
  margin: 1rem;
  border-radius: 0.25rem;
  text-align: center;
}

</style>
